import { Address3IndexPipe } from './address3-index.pipe';
import { Address3NamePipe } from './address3-name.pipe';
import { Address3SeparatorPipe } from './address3-separator.pipe';
import { ApplicationStageNamePipe } from './application-stage-name.pipe';
import { BenefitIconPipe } from './benefit-icon.pipe';
import { BenefitIndexPipe } from './benefit-index.pipe';
import { BenefitNamePipe } from './benefit-name.pipe';
import { CharDaystringPipe } from './char-daystring.pipe';
import { CommonModule } from '@angular/common';
import { ControlRequiredTextPipe } from './control-required-text.pipe';
import { CountSuggestionRoundPipe } from './count-suggestion-round.pipe';
import { CurrencyLocalPipe } from './currency-local.pipe';
import { DynamicPipe } from './dynamic.pipe';
import { EducationPipePipe } from './education-pipe.pipe';
import { EmployeeLastApplicationsPipe } from './employee-last-applications.pipe';
import { EmployeeTooltipDownloadDatePipe } from './employee-tooltip-download-date.pipe';
import { EmployeeTooltipResumeDatePipe } from './employee-tooltip-resume-date.pipe';
import { EmployerTypeColorPipe } from './employer-type-color.pipe';
import { HourMinutePipe } from './hour-minute.pipe';
import { LanguageLevelNamePipe } from './language-level-name.pipe';
import { LanguageLevelNameSliderPipe } from './language-level-name-slider.pipe';
import { LevelNamePipe } from './level-name.pipe';
import { NgModule } from '@angular/core';
import { PositionCurrentPipePipe } from './position-current-pipe.pipe';
import { PriorityEmployeeLabelSliderPipe } from './priority-employee-label-slider.pipe';
import { ProfileUpdateFilterNamePipe } from './profile-update-filter-name.pipe';
import { TicIndexPipe } from './tic-index.pipe';
import { TicNamePipe } from './tic-name.pipe';
import { UrlNewTabPipe } from './url-new-tab.pipe';
import { ValidationInfoMessagePipe } from './validation-info-message.pipe';
import { WhatsappFormatNumberPipe } from './whatsapp-format-number.pipe';
import { PositionNamePipe } from './position-name.pipe';
import { PositionIndexPipe } from './position-index.pipe';
import { FilterCountPipe } from './filter-count.pipe';
import { TicIndexNewPipe } from './tic-index-new.pipe';
import { EmployeeApplicationsPipe } from '@app/components/employer-search-talent/pipes/employee-applications.pipe';
import { ArraySeparatorPipe } from './array-separator.pipe';
import { UserRoleEmployerNamePipe } from './user-role-employer-name.pipe';
import { TicSpecialtyIndexPipe } from './ticSpecialty-index.pipe';
import { TicSpecialtyNamePipe } from './ticSpecialty-name.pipe';
import { IsActiveRoutePipe } from './isActiveRoute.pipe';
import { RoleNamePipe } from './role-name.pipe';
import { GenericTextPipe } from './generic-text.pipe';

@NgModule({
  declarations: [
    RoleNamePipe,
    Address3IndexPipe,
    Address3NamePipe,
    Address3SeparatorPipe,
    ApplicationStageNamePipe,
    BenefitIconPipe,
    BenefitIndexPipe,
    BenefitNamePipe,
    CharDaystringPipe,
    ControlRequiredTextPipe,
    CountSuggestionRoundPipe,
    CurrencyLocalPipe,
    DynamicPipe,
    GenericTextPipe,
    EducationPipePipe,
    EmployeeLastApplicationsPipe,
    EmployeeTooltipDownloadDatePipe,
    EmployeeTooltipResumeDatePipe,
    EmployerTypeColorPipe,
    HourMinutePipe,
    LanguageLevelNamePipe,
    LanguageLevelNameSliderPipe,
    LevelNamePipe,
    PositionCurrentPipePipe,
    PriorityEmployeeLabelSliderPipe,
    ProfileUpdateFilterNamePipe,
    TicIndexPipe,
    TicIndexNewPipe,
    TicNamePipe,
    TicSpecialtyIndexPipe,
    TicSpecialtyNamePipe,
    UrlNewTabPipe,
    ValidationInfoMessagePipe,
    WhatsappFormatNumberPipe,
    PositionIndexPipe,
    PositionNamePipe,
    FilterCountPipe,
    EmployeeApplicationsPipe,
    ArraySeparatorPipe,
    UserRoleEmployerNamePipe,
    IsActiveRoutePipe
  ],
  imports: [
    CommonModule
  ],
  exports: [
    RoleNamePipe,
    Address3IndexPipe,
    Address3NamePipe,
    Address3SeparatorPipe,
    ApplicationStageNamePipe,
    BenefitIconPipe,
    BenefitIndexPipe,
    BenefitNamePipe,
    CharDaystringPipe,
    ControlRequiredTextPipe,
    CountSuggestionRoundPipe,
    CurrencyLocalPipe,
    DynamicPipe,
    GenericTextPipe,
    EducationPipePipe,
    EmployeeLastApplicationsPipe,
    EmployeeTooltipDownloadDatePipe,
    EmployeeTooltipResumeDatePipe,
    EmployerTypeColorPipe,
    HourMinutePipe,
    LanguageLevelNamePipe,
    LanguageLevelNameSliderPipe,
    LevelNamePipe,
    PositionCurrentPipePipe,
    PriorityEmployeeLabelSliderPipe,
    ProfileUpdateFilterNamePipe,
    TicIndexPipe,
    TicIndexNewPipe,
    TicNamePipe,
    TicSpecialtyIndexPipe,
    TicSpecialtyNamePipe,
    UrlNewTabPipe,
    ValidationInfoMessagePipe,
    WhatsappFormatNumberPipe,
    PositionIndexPipe,
    PositionNamePipe,
    FilterCountPipe,
    EmployeeApplicationsPipe,
    ArraySeparatorPipe,
    UserRoleEmployerNamePipe,
    IsActiveRoutePipe
  ],
  providers: [
    Address3IndexPipe,
    Address3NamePipe,
    BenefitIndexPipe,
    BenefitNamePipe,
    PositionIndexPipe,
    PositionNamePipe,
    ProfileUpdateFilterNamePipe,
    TicIndexPipe,
    TicIndexNewPipe,
    TicNamePipe,
    TicSpecialtyIndexPipe,
    TicSpecialtyNamePipe,
  ]
})
export class PipesModule { }

